import React from "react";
import { css } from "emotion";
import { theme } from "../Theme";

const h1Style = css`
  font-size: ${theme.fontSizes[6]};
`;
const h2Style = css`
  font-size: ${theme.fontSizes[5]};
`;
const h3Style = css`
  font-size: ${theme.fontSizes[4]};
`;
const h4Style = css`
  font-size: ${theme.fontSizes[4]};
`;
const h5Style = css`
  font-size: ${theme.fontSizes[3]};
`;
const h6Style = css`
  font-size: ${theme.fontSizes[2]};
`;
const pStyle = css`
  font-size: ${theme.fontSizes[2]};
`;

function Typography({ variant = "p", styleVariant, mb, children }) {
  function getStyle(v) {
    switch (v) {
      case "h1":
        return h1Style;
      case "h2":
        return h2Style;
      case "h3":
        return h3Style;
      case "h4":
        return h4Style;
      case "h5":
        return h5Style;
      case "h6":
        return h6Style;
      default:
        return pStyle;
    }
  }

  const Tag = variant;
  return (
    <Tag
      className={getStyle(styleVariant ?? variant)}
      style={{ marginBottom: mb }}
    >
      {children}
    </Tag>
  );
}

export default Typography;
